// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"107":"general-themes-tr","402":"general-themes-ru","496":"general-themes-en"}[chunkId] || chunkId) + ".ru." + {"15":"7560a06fcbf4e5ea5670","107":"57018c6ba03b8e182cf5","402":"93f9c08d7e782660c5e2","496":"7e9252dc5e70fbe67827","540":"80a3d46d873e08838c2e","615":"4e9eebacf5e064b1a948"}[chunkId] + ".js";
};